import Vue from 'vue'
import Vuex from 'vuex'

import { AxiosResponse } from 'axios'
import Notifications from '@/store/notifications/notifications'
import { SocialStreamApiRequest, SocialStreamConfig, SocialStreamCatalogs } from './socialStreamApiRequestHelper'

Vue.use(Vuex)

export interface SocialStreamConfigState {
    dataLoading: boolean,
    data: {
        socialStreamConfig: SocialStreamConfig,
        socialStreamCatalogs: SocialStreamCatalogs,
    }
}

const getInitialState = (): SocialStreamConfigState => ({
    dataLoading: true,
    data: {
        socialStreamConfig: {    
            socialStreamId: null,
            instagramHandle: '',
            includedHashTag: '',
            influencerSubpage: '',
            influencerSubpageHeader: '',
            influencerProfileImage: '',
            filterAvailable: true,
            clickthrough: null,
        },
        socialStreamCatalogs: {        
          productsCatalogId: '',
          productsCatalogName: '',
          instagramPostsCatalogId: '',
          instagramPostsCatalogName: '',
        }
    }
})

export default new Vuex.Store({
  state: getInitialState(),
  mutations: {
    setSocialStreamId(state: SocialStreamConfigState, socialStreamId: string) {
      state.data.socialStreamConfig.socialStreamId = socialStreamId
    },
    setInstagramHandle(state: SocialStreamConfigState, instagramHandle: string) {
      state.data.socialStreamConfig.instagramHandle = instagramHandle
    },
    setIncludedHashTag(state: SocialStreamConfigState, includedHashTag: string) {
      state.data.socialStreamConfig.includedHashTag = includedHashTag
    },
    setInfluencerSubpage(state: SocialStreamConfigState, influencerSubpage: string) {
      state.data.socialStreamConfig.influencerSubpage = influencerSubpage
    },
    setInfluencerSubpageHeader(state: SocialStreamConfigState, influencerSubpageHeader: string) {
      state.data.socialStreamConfig.influencerSubpageHeader = influencerSubpageHeader
    },
    setInfluencerProfileImage(state: SocialStreamConfigState, influencerProfileImage: string) {
      state.data.socialStreamConfig.influencerProfileImage = influencerProfileImage
    },
    setFilterAvailable(state: SocialStreamConfigState, filterAvailable: boolean) {
      state.data.socialStreamConfig.filterAvailable = filterAvailable
    },
    setClickthrough(state: SocialStreamConfigState, clickthrough: string) {
      state.data.socialStreamConfig.clickthrough = clickthrough
    },
    setSocialStreamConfig(state: SocialStreamConfigState, config: SocialStreamConfig) {
      state.data.socialStreamConfig = config
    },
    setSocialStreamCatalogs(state: SocialStreamConfigState, catalogs: SocialStreamCatalogs) {
      state.data.socialStreamCatalogs = catalogs
    },
    setInitialState(state: SocialStreamConfigState){
        state.dataLoading = false
        state.data.socialStreamConfig = {
            socialStreamId: null,
            instagramHandle: '',
            includedHashTag: '',
            influencerSubpage: '',
            influencerSubpageHeader: '',
            influencerProfileImage: '',
            filterAvailable: true,
            clickthrough: null,
        }
        state.data.socialStreamCatalogs = {
            productsCatalogId: '',
            productsCatalogName: '',
            instagramPostsCatalogId: '',
            instagramPostsCatalogName: '',
        }
    },
    setDataLoading(state: SocialStreamConfigState, dataLoading: boolean) {
        state.dataLoading = dataLoading
    }
  },
  actions: {
    updateInstagramHandle(context: any, instagramHandle: string) {
      context.commit('setInstagramHandle', instagramHandle)
    },
    updateIncludedHashTag(context: any, includedHashTag: string) {
      context.commit('setIncludedHashTag', includedHashTag)
    },
    updateInfluencerSubpage(context: any, influencerSubpage: string) {
      context.commit('setInfluencerSubpage', influencerSubpage)
    },
    updateInfluencerSubpageHeader(context: any, influencerSubpageHeader: string) {
      context.commit('setInfluencerSubpageHeader', influencerSubpageHeader)
    },
    updateInfluencerProfileImage(context: any, influencerProfileImage: string) {
      context.commit('setInfluencerProfileImage', influencerProfileImage)
    },
    updateFilterAvailable(context: any, filterAvailable: boolean) {
      context.commit('setFilterAvailable', filterAvailable)
    },
    updateClickthrough(context: any, clickthrough: string) {
      context.commit('setClickthrough', clickthrough)
    },
    storeSocialStreamConfig(context: any) {
            
      const storeResponse = SocialStreamApiRequest.storeSocialStreamConfig(context.state.data.socialStreamConfig)

      return storeResponse
        .then((response: AxiosResponse<SocialStreamConfig>) => {
          if (response.status !== 200) {
            throw Error('Status code is not 200')
          }
          return response
        })
        .catch(error => {
          Notifications.commit('addError', Error('socialStream.config.storeError'), { root: true })
          throw error
        })
    },
    getSocialStreamConfig(context: any, configId: string) {
        if(configId == ''){
            context.commit('setInitialState')
            return
        }
        context.commit('setSocialStreamId', configId)
        SocialStreamApiRequest.getSocialStreamConfig(configId).then(results => {
            context.commit('setSocialStreamConfig', {
                socialStreamId: configId,
                instagramHandle: results.data.instagramHandle,
                includedHashTag: results.data.includedHashTag,
                influencerSubpage: results.data.influencerSubpage,
                influencerSubpageHeader: results.data.influencerSubpageHeader,
                influencerProfileImage: results.data.influencerProfileImage,
                filterAvailable: results.data.filterAvailable,
                clickthrough: results.data.clickthrough,
            })
            context.commit('setSocialStreamCatalogs', {
                productsCatalogId: results.data.productsCatalogId,
                productsCatalogName: results.data.productsCatalogName,
                instagramPostsCatalogId: results.data.instagramPostsCatalogId,
                instagramPostsCatalogName: results.data.instagramPostsCatalogName,
            })
            context.commit('setDataLoading', false)
        })
    }
  }
})
